/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Footer_SupportInputs */

const en_portal_footer_support = /** @type {(inputs: Portal_Footer_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const pl_portal_footer_support = /** @type {(inputs: Portal_Footer_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wsparcie`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Portal_Footer_SupportInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_footer_support = /** @type {((inputs?: Portal_Footer_SupportInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Footer_SupportInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_footer_support(inputs)
	return en_portal_footer_support(inputs)
});